import React from "react";
import ReactDOM from "react-dom/client";
import AukusSupplyChain from "./aukus-supply-chain";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AukusSupplyChain />
  </React.StrictMode>,
);
